import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getFranjasHorarios,
  insertFranjaHorario,
  updateFranjaHorario,
  deleteFranjaHorario,
  getUbicacionesHorarios,
  getFranjaHorarioById,
  getFranjasHorariosEditar,
  deleteFranjaHorarioEditar,
  insertFechaHorario,
  updateFranjaHorarioEditar,
  getUbicaciones,
  getUbicacionesHorariosNoEspecial,
  getUbicacionesMRW,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FRANJAS_HORARIOS() {
  try {
    const franjasHorariosData = yield call(getFranjasHorarios)
    if (franjasHorariosData.ok) {
      yield put({
        type: actions.FRANJAS_HORARIOS_LOAD_SUCCEEDED,
        payload: franjasHorariosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar franjas horarios')
      put({
        type: actions.FRANJAS_HORARIOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FRANJAS_HORARIOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FRANJAS_HORARIOS_EDITAR(action) {
  try {
    const franjasHorariosEditarData = yield call(getFranjasHorariosEditar, action.payload)
    if (franjasHorariosEditarData.ok) {
      yield put({
        type: actions.FRANJAS_HORARIOS_EDITAR_LOAD_SUCCEEDED,
        payload: franjasHorariosEditarData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar franjas horarios editar')
      put({
        type: actions.FRANJAS_HORARIOS_EDITAR_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FRANJAS_HORARIOS_EDITAR_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FRANJA_HORARIO(action) {
  try {
    const franjaHorarioObj = yield call(insertFranjaHorario, action.payload)
    if (franjaHorarioObj.ok) {
      putMessage(messageType.SUCCESS, 'Franja Horario creada correctamente')
      yield put({
        type: actions.FRANJA_HORARIO_INSERT_SUCCEEDED,
        payload: franjaHorarioObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear franja horario')
      yield put({
        type: actions.FRANJA_HORARIO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear franja horario')
    yield all([
      put({
        type: actions.FRANJA_HORARIO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FRANJA_HORARIO(action) {
  try {
    const franjaHorarioObj = yield call(updateFranjaHorario, action.payload)
    if (franjaHorarioObj.ok) {
      putMessage(messageType.SUCCESS, 'Franja horario modificada correctamente')
      yield put({
        type: actions.FRANJA_HORARIO_UPDATE_SUCCEEDED,
        payload: franjaHorarioObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar franja horario')
      yield put({
        type: actions.FRANJA_HORARIO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar franja horario')
    yield all([
      put({
        type: actions.FRANJA_HORARIO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FRANJA_HORARIO_EDITAR(action) {
  try {
    const franjaHorarioObj = yield call(updateFranjaHorarioEditar, action.payload)
    if (franjaHorarioObj.ok) {
      putMessage(messageType.SUCCESS, 'Franja horario modificada correctamente')
      yield put({
        type: actions.FRANJA_HORARIO_EDITAR_UPDATE_SUCCEEDED,
        payload: franjaHorarioObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar franja horario')
      yield put({
        type: actions.FRANJA_HORARIO_EDITAR_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar franja horario')
    yield all([
      put({
        type: actions.FRANJA_HORARIO_EDITAR_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FRANJA_HORARIO(action) {
  try {
    const franjaHorarioResult = yield call(deleteFranjaHorario, action.payload)
    if (franjaHorarioResult.ok) {
      putMessage(messageType.SUCCESS, 'Franja horario eliminada correctamente')
      yield put({
        type: actions.FRANJA_HORARIO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar franja horario')
      yield put({
        type: actions.FRANJA_HORARIO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar franja horario')
    yield all([
      put({
        type: actions.FRANJA_HORARIO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FRANJA_HORARIO_EDITAR(action) {
  try {
    const franjaHorarioEditarResult = yield call(deleteFranjaHorarioEditar, action.payload)
    if (franjaHorarioEditarResult.ok) {
      putMessage(messageType.SUCCESS, 'Franja horario eliminada correctamente')
      yield put({
        type: actions.FRANJA_HORARIO_EDITAR_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar franja horario')
      yield put({
        type: actions.FRANJA_HORARIO_EDITAR_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar franja horario')
    yield all([
      put({
        type: actions.FRANJA_HORARIO_EDITAR_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_UBICACIONES_HORARIOS(action) {
  try {
    const ubicacionesHorariosData = yield call(getUbicacionesHorarios, action.payload)
    if (ubicacionesHorariosData.ok) {
      yield put({
        type: actions.UBICACIONES_HORARIOS_LOAD_SUCCEEDED,
        payload: ubicacionesHorariosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ubicaciones horarios')
      put({
        type: actions.UBICACIONES_HORARIOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.UBICACIONES_HORARIOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_FRANJA_HORARIO_BY_ID(action) {
  try {
    const franjaHorarioData = yield call(getFranjaHorarioById, action.payload)
    if (franjaHorarioData.ok) {
      yield put({
        type: actions.FRANJA_HORARIO_BY_ID_LOAD_SUCCEEDED,
        payload: franjaHorarioData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar franja horario por Id')
      put({
        type: actions.FRANJA_HORARIO_BY_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FRANJA_HORARIO_BY_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FECHA_HORARIO(action) {
  try {
    const fechaHorarioObj = yield call(insertFechaHorario, action.payload)
    if (fechaHorarioObj.ok) {
      putMessage(messageType.SUCCESS, 'Franja Horario creada correctamente')
      yield put({
        type: actions.FECHA_HORARIO_INSERT_SUCCEEDED,
        payload: fechaHorarioObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear franja horario')
      yield put({
        type: actions.FECHA_HORARIO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear franja horario')
    yield all([
      put({
        type: actions.FECHA_HORARIO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_UBICACIONES() {
  try {
    const ubicacionesData = yield call(getUbicaciones)
    if (ubicacionesData.ok) {
      yield put({
        type: actions.UBICACIONES_LOAD_SUCCEEDED,
        payload: ubicacionesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ubicaciones')
      put({
        type: actions.UBICACIONES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.UBICACIONES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_UBICACIONES_HORARIOS_NO_ESPECIAL() {
  try {
    const ubicacionesData = yield call(getUbicacionesHorariosNoEspecial)
    if (ubicacionesData.ok) {
      yield put({
        type: actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_SUCCEEDED,
        payload: ubicacionesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ubicaciones horarios no especial')
      put({
        type: actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_UBICACIONES_MRW() {
  try {
    const ubicacionesMRWData = yield call(getUbicacionesMRW)
    if (ubicacionesMRWData.ok) {
      yield put({
        type: actions.UBICACIONES_MRW_LOAD_SUCCEEDED,
        payload: ubicacionesMRWData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ubicaciones horarios MRW')
      put({
        type: actions.UBICACIONES_MRW_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.UBICACIONES_MRW_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FRANJAS_HORARIOS_LOAD_REQUESTED, GET_FRANJAS_HORARIOS),
    takeEvery(actions.FRANJA_HORARIO_INSERT_REQUESTED, INSERT_FRANJA_HORARIO),
    takeEvery(actions.FRANJA_HORARIO_UPDATE_REQUESTED, UPDATE_FRANJA_HORARIO),
    takeEvery(actions.FRANJA_HORARIO_DELETE_REQUESTED, DELETE_FRANJA_HORARIO),
    takeEvery(actions.UBICACIONES_HORARIOS_LOAD_REQUESTED, GET_UBICACIONES_HORARIOS),
    takeEvery(actions.FRANJA_HORARIO_BY_ID_LOAD_REQUESTED, GET_FRANJA_HORARIO_BY_ID),
    takeEvery(actions.FRANJAS_HORARIOS_EDITAR_LOAD_REQUESTED, GET_FRANJAS_HORARIOS_EDITAR),
    takeEvery(actions.FRANJA_HORARIO_EDITAR_DELETE_REQUESTED, DELETE_FRANJA_HORARIO_EDITAR),
    takeEvery(actions.FECHA_HORARIO_INSERT_REQUESTED, INSERT_FECHA_HORARIO),
    takeEvery(actions.FRANJA_HORARIO_EDITAR_UPDATE_REQUESTED, UPDATE_FRANJA_HORARIO_EDITAR),
    takeEvery(actions.UBICACIONES_LOAD_REQUESTED, GET_UBICACIONES),
    takeEvery(actions.UBICACIONES_MRW_LOAD_REQUESTED, GET_UBICACIONES_MRW),
    takeEvery(
      actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_REQUESTED,
      GET_UBICACIONES_HORARIOS_NO_ESPECIAL,
    ),
  ])
}
